import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export const RARITY_META = {
  common: { label: 'Common', color: '#9CA3AF', ring: 'ring-white/10' },
  uncommon: { label: 'Uncommon', color: '#40916C', ring: 'ring-primary/40' },
  rare: { label: 'Rare', color: '#5FA9E5', ring: 'ring-sky-400/50' },
  epic: { label: 'Epic', color: '#B27BC7', ring: 'ring-fuchsia-400/50' },
  legendary: { label: 'Legendary', color: '#E9C46A', ring: 'ring-accent/60' },
};

export const CATEGORY_IMAGES = {
  Birds: 'https://images.unsplash.com/photo-1444464666168-49d633b86797?w=1000&auto=format&fit=crop',
  Mammals: 'https://images.unsplash.com/photo-1484406566174-9da000fda645?w=1000&auto=format&fit=crop',
  Plants: 'https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?w=1000&auto=format&fit=crop',
  Trees: 'https://images.unsplash.com/photo-1448375240586-882707db888b?w=1000&auto=format&fit=crop',
  Reptiles: 'https://images.unsplash.com/photo-1585095595274-aeffbc451320?w=1000&auto=format&fit=crop',
  Amphibians: 'https://images.unsplash.com/photo-1591873493674-06adf50fe6dd?w=1000&auto=format&fit=crop',
  Fish: 'https://images.unsplash.com/photo-1524704654690-b56c05c78a00?w=1000&auto=format&fit=crop',
  Insects: null,
  Mushrooms: 'https://images.unsplash.com/photo-1518123954648-91ee29e21811?w=1000&auto=format&fit=crop',
};

// Category theming — tint gradients + monogram fallback if the remote
// stock photo fails to load. Keeps the collection page beautiful even
// when the CDN blips.
export const CATEGORY_META = {
  Birds:      { tint: 'from-sky-500/70 to-teal-500/60',       glyph: 'B' },
  Mammals:    { tint: 'from-amber-600/70 to-orange-800/60',    glyph: 'M' },
  Plants:     { tint: 'from-emerald-500/70 to-lime-700/60',    glyph: 'P' },
  Trees:      { tint: 'from-green-700/70 to-emerald-900/60',   glyph: 'T' },
  Reptiles:   { tint: 'from-lime-600/70 to-stone-800/60',      glyph: 'R' },
  Amphibians: { tint: 'from-teal-500/70 to-indigo-800/60',     glyph: 'A' },
  Fish:       { tint: 'from-cyan-500/70 to-blue-900/60',       glyph: 'F' },
  Insects:    { tint: 'from-yellow-500/70 to-rose-700/60',     glyph: 'I' },
  Mushrooms:  { tint: 'from-rose-500/70 to-amber-900/60',      glyph: 'M' },
};
